import { createContext, useCallback, useContext, useMemo } from "react";
import { useLocalStorage } from "./useLocalStorage";
const AuthContext = createContext();

const decodeToken = (token) => {
  try {
    const payload = token.split('.')[1];
    return JSON.parse(atob(payload));
  } catch {
    return {};
  }
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useLocalStorage("user", null);

  // call this function when you want to authenticate the user
  const login = useCallback(async (data) => {
    setUser(data);
  }, [setUser]);

  // call this function to sign out logged in user
  const logout = useCallback(() => {
    setUser(null);
  }, [setUser]);

  const decoded = useMemo(() => user?.token ? decodeToken(user.token) : {}, [user]);

  const value = useMemo(
    () => ({
      user,
      login,
      logout,
      capabilities: decoded.capabilities || [],
      role_name: decoded.role_name || null,
      authorization_level: decoded.LbAuthLevel || null,
      isAdmin: decoded.role_name === 'admin' || decoded.LbAuthLevel === 'SUPER_ADMIN',
      isSuperAdmin: decoded.LbAuthLevel === 'SUPER_ADMIN',
    }),
    [user, login, logout, decoded]
  );
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};
